export default __webpack_public_path__ + "static/media/loading3.27a1c9f5.gif";